import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { StoreProvider } from "./context/StoreContext";
import { Layout } from "./components/site/Layout";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Product from "./pages/Product";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmation, { PaymentDemo } from "./pages/OrderConfirmation";
import TrackOrder from "./pages/TrackOrder";
import Account from "./pages/Account";
import { About, Contact, FAQ, Shipping, Returns, Privacy, Terms } from "./pages/InfoPages";
import AdminLayout, { AdminLogin } from "./admin/AdminLayout";
import Overview from "./admin/Overview";
import { ProductList, ProductEditor } from "./admin/Products";
import Orders from "./admin/Orders";
import { Customers, Promotions, Delivery } from "./admin/Manage";
import Settings, { InboxPage } from "./admin/Settings";

const P = {
  new: { collection: "new" }, sneakers: { category: "sneakers" }, men: { gender: "Men" }, women: { gender: "Women" }, sale: { collection: "sale" },
};

function NotFound() {
  return <div className="container-x py-24"><h1 className="font-display text-7xl">404</h1><p className="text-zinc-400">This page took a different step.</p></div>;
}

export default function App() {
  return (
    <div className="App">
      <StoreProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/new-arrivals" element={<Shop key="new" title="New Arrivals" eyebrow="Fresh drops" preset={P.new} />} />
              <Route path="/sneakers" element={<Shop key="sneakers" title="Sneakers" eyebrow="Heat on feet" preset={P.sneakers} />} />
              <Route path="/men" element={<Shop key="men" title="Men's Footwear" eyebrow="For him" preset={P.men} />} />
              <Route path="/women" element={<Shop key="women" title="Women's Footwear" eyebrow="For her" preset={P.women} />} />
              <Route path="/sale" element={<Shop key="sale" title="Sale" eyebrow="Limited time" preset={P.sale} />} />
              <Route path="/products/:slug" element={<Product />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-confirmation/:number" element={<OrderConfirmation />} />
              <Route path="/payment/demo/:number" element={<PaymentDemo />} />
              <Route path="/track-order" element={<TrackOrder />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/returns" element={<Returns />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/account" element={<Account />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Overview />} />
              <Route path="products" element={<ProductList />} />
              <Route path="products/:id" element={<ProductEditor />} />
              <Route path="orders" element={<Orders />} />
              <Route path="customers" element={<Customers />} />
              <Route path="promotions" element={<Promotions />} />
              <Route path="delivery" element={<Delivery />} />
              <Route path="inbox" element={<InboxPage />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </StoreProvider>
    </div>
  );
}
